export const EMPLOYEES_LIMIT = 6;
